import { exportSpecForFormat, formatCatalogEntry } from "./format-catalog.js";
export { CANVAS_PRESETS, DEFAULT_CANVAS } from "./format-catalog.js";
export const MENU_FORMATS = [
    'digital_book',
    'single_page',
    'flyer',
    'table_tent',
    'wall_board',
    'tv_slide',
    'interior_sheet',
    'pocket_menu',
    'social_post',
];
/** True when this document is a restaurant frozen page book. */
export function isFrozenDesign(document) {
    return document?.mode === 'frozen' && Array.isArray(document.pages);
}
export const DEFAULT_FLOW_RULES = {
    includeCover: true,
    includeBackCover: true,
    includeTableOfContents: true,
    dividers: 'auto',
    includeInfoPage: true,
    varietyWindow: 3,
    balanceSpreads: true,
    minOrphanItems: 2,
    allowSpotlights: true,
    maxSpotlights: 3,
};
/**
 * Book chrome (cover, TOC, dividers, spotlights) belongs on `digital_book`.
 * Flat and scene formats pack dishes; a cover-first flyer reads as an empty sheet.
 */
export function flowRulesForFormat(format, source) {
    const base = { ...(source ?? DEFAULT_FLOW_RULES) };
    if (format === 'digital_book')
        return base;
    if (format === 'table_tent') {
        return {
            ...base,
            includeTableOfContents: false,
            dividers: 'none',
            includeInfoPage: false,
            allowSpotlights: false,
            maxSpotlights: 0,
            balanceSpreads: false,
            includeBackCover: false,
        };
    }
    return {
        ...base,
        includeCover: false,
        includeBackCover: false,
        includeTableOfContents: false,
        dividers: 'none',
        includeInfoPage: false,
        allowSpotlights: false,
        maxSpotlights: 0,
        balanceSpreads: false,
    };
}
export function resolveMenuFormat(template) {
    return template.format ?? 'digital_book';
}
/** Display-only id for templates that have no explicit `variants[]`. */
export function syntheticLegacyVariantId(format) {
    return `legacy-${format}`;
}
export function isLegacyFormatVariantId(variantId) {
    return typeof variantId === 'string' && variantId.startsWith('legacy-');
}
/** True when `variantId` is the synthetic branch for a document with no explicit variants. */
export function matchesSyntheticLegacyVariant(template, variantId) {
    if (!variantId || template.variants?.length)
        return false;
    return variantId === syntheticLegacyVariantId(resolveMenuFormat(template));
}
export function resolveTemplateVariant(template, variantId, options = {}) {
    const variant = variantId
        ? template.variants?.find((entry) => entry.id === variantId)
        : undefined;
    if (!variant) {
        if (variantId && options.strict !== false) {
            // Synthetic legacy ids advertise the root document; treat as no pin.
            if (matchesSyntheticLegacyVariant(template, variantId)) {
                return template;
            }
            throw new Error(`Unknown template format variant "${variantId}"`);
        }
        return template;
    }
    return {
        ...template,
        format: variant.format,
        canvas: variant.canvas,
        blueprints: variant.blueprints,
        flow: variant.flow,
    };
}
/** Returns explicit variants while giving legacy templates a stable branch. */
export function templateFormatVariants(template) {
    if (template.variants?.length)
        return template.variants;
    const format = resolveMenuFormat(template);
    return [
        {
            id: syntheticLegacyVariantId(format),
            format,
            label: formatCatalogEntry(format).label,
            canvas: template.canvas,
            blueprints: template.blueprints,
            flow: template.flow,
            export: exportSpecForFormat(format),
        },
    ];
}
export function blueprintsForGroup(template, group) {
    return template.blueprints.filter((blueprint) => blueprint.group === group);
}
//# sourceMappingURL=template.js.map